export interface MembranePoint {
  x: number;
  y: number;
  angle: number;
}

function roundTo(value: number, decimals: number): number {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}

export function quantizePosition(value: number): number {
  return roundTo(value, 1);
}

export function quantizeRotation(value: number): number {
  return roundTo(value, 3);
}

export function quantizeMembranePoints(points: MembranePoint[]): MembranePoint[] {
  return points.map((p) => ({
    x: quantizePosition(p.x),
    y: quantizePosition(p.y),
    angle: quantizeRotation(p.angle)
  }));
}

export function estimatePayloadBytes(payload: unknown): number {
  try {
    const json = JSON.stringify(payload);
    const maybeBuffer = (globalThis as { Buffer?: { byteLength: (text: string, encoding?: string) => number } }).Buffer;
    if (maybeBuffer) {
      return maybeBuffer.byteLength(json, 'utf8');
    }
    return new TextEncoder().encode(json).length;
  } catch {
    return 0;
  }
}
